var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pick-rating"},[_c('Icon',{attrs:{"name":"chart-arrow"}}),_vm._v(" "+_vm._s(_vm.value)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }